<template>
	<div>
		<h1>Now generating and saving chart...</h1>
		<div v-if="ready" class="printable-chart">
			<chart-line v-if="data.type==='line'" v-bind:data="data" mode="printable" v-on:saveDataUrl="saveDataUrl"></chart-line>
			<chart-pie v-if="data.type==='pie'" v-bind:data="data" mode="printable" v-on:saveDataUrl="saveDataUrl"></chart-pie>
			<chart-bar v-if="data.type==='bar'" v-bind:data="data" mode="printable" v-on:saveDataUrl="saveDataUrl"></chart-bar>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
export default {
	name: 'single-graph',
	data() {
		return {
			data: false,
			ready: false
		}
	},
	methods: {
		getData() {
			axios.get(
				window.dcSite.apiRoute + 'get/graph/' + this.$route.params.id, 
				{
					headers: {
						'X-WP-Nonce': window.dcSite.nonce
					}
				}
      		).then(response => {
				if (response.data.success) {
					this.data = response.data
				} 
			})
		},
		saveDataUrl(data) {
			axios.post(
				window.dcSite.apiRoute + 'save/graph/' + this.$route.params.id, 
				{ 
					dataURL : data.dataURL
				},
				{
					headers: {
						'X-WP-Nonce': window.dcSite.nonce
					}
				}
			).then(response => {
				if (response.data.success) {
					window.location.href = window.location.origin + '/wp-admin/post.php?post=' + this.$route.params.id + '&action=edit';
					return;
				} 
			})
		}
	},
	mounted() {
		this.getData()
		setTimeout(() => {
			this.ready = true;
		}, 1000);
	},
	beforeRouteUpdate(to, from, next) {
		this.getData()
		next()
	},
	components: {
		ChartPie: () => import('../components/blocks/graph/Pie'),
		ChartLine: () => import('../components/blocks/graph/Line'),
		ChartBar: () => import('../components/blocks/graph/Bar'),
	}
}
</script>

<style lang="scss">
  canvas {
	background-color: #333941;
  }
</style>